// @ts-check
import classNames from 'classnames';
import React from 'react';
import AccentBar from './../Core/AccentBar';

import './Card.scss';

/**
 * @typedef CardProps
 * @property {Function} [onExit] An optional callback indicating there should be a close button.
 */
/** @type {import('~/types/React').ReactFC<CardProps>} */
const Card = ({ className, onExit, ...rest }) => (
	<div {...rest} className={classNames('card-container', className)}>
		<AccentBar className="card-accent" />

		{!!onExit && (
			<button aria-label="close" className="btn back-button" onClick={() => onExit()}>
				<i aria-hidden="true" className="icon">
					close
				</i>
			</button>
		)}

		<div className={classNames('card-content', `${className}-content`)}>{rest.children}</div>
	</div>
);

export default Card;
